var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShopperLevel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 30.5,
    fill: "#FFE600",
    fillOpacity: 0.2,
    stroke: "#FFD600",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.598 19.966V22.644H39.826V29.248H32.598V31.926H42.66V19.966H32.598ZM32.572 24.672V27.194H40.996V24.672H32.572ZM37.642 30.366L35.276 30.834C36.394 36.502 38.422 40.948 42.374 43.236C42.816 42.404 43.7 41.156 44.35 40.558C40.684 38.816 38.604 34.968 37.642 30.366ZM42.036 32.212C41.048 33.33 39.28 34.812 38.11 35.618L39.644 37.542C40.918 36.788 42.582 35.54 43.96 34.422L42.036 32.212ZM31.194 43.418C31.818 43.002 32.806 42.638 37.902 41.338C37.798 40.662 37.746 39.388 37.772 38.504L32.182 39.726L30.934 40.714L31.194 43.418ZM31.194 43.418C31.194 42.3 34.132 40.584 34.132 40.584V19.966H31.064V38.712C31.064 39.908 30.414 40.636 29.868 40.974C30.31 41.494 30.986 42.716 31.194 43.418ZM23.446 18.978C22.666 21.292 21.288 23.476 19.728 24.932C20.196 25.66 20.95 27.298 21.184 27.974C23.264 25.998 25.11 22.852 26.202 19.81L23.446 18.978ZM23.55 21.448L22.952 24.412H29.608V21.448H23.55ZM22.12 26.31V29.092H29.426V26.31H22.12ZM20.56 31.64V34.422H29.972V31.64H20.56ZM23.68 43.34C24.226 42.846 25.136 42.352 30.128 39.908C29.946 39.258 29.764 38.01 29.712 37.204L24.148 39.7L23.212 40.688L23.68 43.34ZM23.68 43.34C23.68 42.326 26.696 40.818 26.696 40.818V27.09H23.732V38.79C23.732 39.882 23.03 40.506 22.484 40.792C22.926 41.39 23.524 42.638 23.68 43.34Z",
    fill: "#FFD600"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopperLevel);
export default __webpack_public_path__ + "static/media/shopper_level.dd27c36151920f9a791f7fc567310673.svg";
export { ForwardRef as ReactComponent };